import axios, { type AxiosError } from 'axios'
import { type HttpGetClient } from '../../data/protocols/adapters/http-get-client'
import { type HttpPostClient } from '../../data/protocols/adapters/http-post-client'
import { type HttpPutClient } from '../../data/protocols/adapters/http-put-client'
import { type HttpDeleteClient } from '../../data/protocols/adapters/http-delete-client'
export class AxiosHttpClient<RequestType, ResponseType> implements
  HttpGetClient<RequestType, ResponseType>,
  HttpPostClient<RequestType, ResponseType>,
  HttpPutClient<RequestType, ResponseType>,
  HttpDeleteClient<RequestType, ResponseType> {
  async get (params: HttpGetClient.Params<RequestType>): Promise<HttpGetClient.Result<ResponseType>> {
    try {
      const response = await axios.get(params.url, { params: params.body, headers: params.headers })
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      return {
        data: axiosError.response?.data as ResponseType,
        status: axiosError.response?.status || 0
      }
    }
  }

  async post (params: HttpPostClient.Params<RequestType>): Promise<HttpPostClient.Result<ResponseType>> {
    try {
      const response = await axios.post(params.url, params.body, { headers: params.headers })
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      return {
        data: axiosError.response?.data as ResponseType,
        status: axiosError.response?.status || 0
      }
    }
  }

  async put (params: HttpPutClient.Params<RequestType>): Promise<HttpPutClient.Result<ResponseType>> {
    try {
      const response = await axios.put(params.url, params.body, { headers: params.headers })
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      return {
        data: axiosError.response?.data as ResponseType,
        status: axiosError.response?.status || 0
      }
    }
  }

  async delete (params: HttpDeleteClient.Params<RequestType>): Promise<HttpDeleteClient.Result<ResponseType>> {
    try {
      const response = await axios.delete(params.url, { params: params.body, headers: params.headers })
      return response
    } catch (error) {
      const axiosError = error as AxiosError
      return {
        data: axiosError.response?.data as ResponseType,
        status: axiosError.response?.status || 0
      }
    }
  }
}
